<template>

            <section class="mob_akcios_area a_new_bordrtwo">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 no-widget-padding">
                            <div class="mob_akcios_conts">
                                <div class="mob_akcios_conts_box">
                                    <div class="akcios_menu_cont">
                                        <div class="akcios_menu_cont_box text-center">
                                            <ul>
                                                <li>AKCIÓS TERMÉKEK</li>
                                            </ul>
                                        </div>
                                    </div>



                                    <div class="mob_akcios_conts_box_carousel">
                                        <div id="recommended-item-carousel-two" class="carousel slide" data-ride="carousel">
                                            <div class="carousel-inner">
                                                <div class="item" :class="{active: i==0}" v-for="(list,i) in products">
                                                    <div class="">
                                                        <div class="product-img-wrapper">
                                                            <div class="single-products">
                                                                <div class="row">


                                                                    <div class="col-sm-3 col-xs-6" v-for="p in list">
                                                                        <!-- <router-link tag="div" :to="'/product/'+p.id" class="soproni_small_single" style="cursor:pointer"> -->
                                                                            <!-- <div class="soproni_small_single_box">
                                                                                <div class="soproni_small_single_box_img text-center">
                                                                                    <img style="width:100%" :src="p.imageUrl" alt="">
                                                                                </div>


                                                                            </div>
                                                                            <div class="soproni_small_below_box">
                                                                                <div class="row">
                                                                                    <div class="col-sm-12">
                                                                                        <div class="soproni_small_single_box_title">
                                                                                            <h5>{{p.name}}</h5>
                                                                                        </div>
                                                                                        <div class="soproni_small_single_box_sub_title">
                                                                                            <p>{{p.price && p.price.toLocaleString('hu')}} Ft <del class="original-price">{{p.originalPrice && p.originalPrice.toLocaleString('hu')}} Ft</del></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> -->
                                                                            <product-list-view style="width: auto" :product="p" :key="p.id"></product-list-view>

                                                                        <!-- </router-link> -->
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>



                                            <a class="right recommended-item-control" href="#recommended-item-carousel-two"  data-slide="next">
                                                <span>Több</span><i class="fa fa-arrow-right" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'
import ProductListView from '@pages/list/ProductListView.vue'

export default{
    mixins:[Endpoints],
    components:{
        ProductListView
    },
    data:function () {
        return {
            products: [],
            small:screen.width<576,
        };
    },
    created: function (){
        var self = this;

        this.connGetDiscountProducts(function (r) {
            var array = r.data.list;

            var i,j,temparray,chunk = self.small?2:4;
            console.log(i);
            for (i=0,j=array.length; i<j; i+=chunk) {
                temparray = array.slice(i,i+chunk);
                self.products.push(temparray);
            }
        })
    },
    methods: {

    }
}
</script>

<style>
.original-price{
    margin-left:0px;
    font-size: 16px;
    color:#999999
}
@media screen and (max-width: 576px){
    .soproni_small_single_box{
        padding: 0px;
    }
    .product-img-wrapper .soproni_small_single_box_img{
        margin-bottom: 0px;
        margin-top: 0px;
    }
}
</style>



// WEBPACK FOOTER //
// DiscountProductsWidget.vue?529c8228